// src/features/dashboard/services/Employee/overviewCard.service.ts

import apiClient
  from '../../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../../api/endpoints';

import type {
  EmployeeSummaryApiResponse,
  EmployeeSummaryRequest,
} from '../../types/Employee/overviewCard.types';

export const getOverviewCard =
  async (
    payload: EmployeeSummaryRequest,
  ): Promise<EmployeeSummaryApiResponse> => {

    const token =
      sessionStorage.getItem(
        'token',
      ) ||
      localStorage.getItem(
        'token',
      );

    const response =
      await apiClient.post(
        ENDPOINTS.EMPLOYEE_SUMMARY,
        payload,
        {
          headers: {
            Authorization:
              token
                ? `Bearer ${token}`
                : '',
          },
        },
      );

    return response.data;
  };